export const filterData = () => {
    return {
        'State of Origin': {label: 'State of Origin', selected: false,
            options: [
                "Abia",
                "Adamawa",
                "Akwa Ibom",
                "Anambra",
                "Bauchi",
                "Bayelsa",
                "Benue",
                "Borno",
                "Cross River",
                "Delta",
                "Ebonyi",
                "Edo",
                "Ekiti",
                "Enugu",
                "Gombe",
                "Imo",
                "Jigawa",
                "Kaduna",
                "Kano",
                "Katsina",
                "Kebbi",
                "Kogi",
                "Kwara",
                "Lagos",
                "Nasarawa",
                "Niger",
                "Ogun",
                "Ondo",
                "Osun",
                "Oyo",
                "Plateau",
                "Rivers",
                "Sokoto",
                "Taraba",
                "Yobe",
                "Zamfara",
                "Abuja (FCT)"
            ]
        },
        'Age Range': { label: 'Age Range', selected: false, options: ['Under 16', '16-20', '21-30', '31-39', '40 and above'] },
        'Gender': { label: 'Gender', selected: false, options: ['Male', 'Female']},
        // 'Grade': {label: 'Grade', selected: false, options:['First class', 'Second class lower', 'Distinction']},
        'Test Score': { label: 'Test Score', selected: false, options: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10","11", "12", "13","14", "15", "16", "17", "18", "19", "20"]},
        // 'Willing to relocate': { label: 'Willing to relocate', selected: false, options: ['Yes', 'No']},
        'Marital Status': { label: 'Marital Status', selected: false, options: ['Single', 'Married', 'Other']},
        // 'Highest Level': { label: 'Highest Level', selected: false, options: ['Doctorate', 'Masters', 'Bachelor', 'Undergraduate', 'Not Applicable']},
        'Region': { label: 'Region', selected: false, options: ['North Central', 'North East', 'North West', 'South East', 'South West', 'South South', 'FCT']},
        'Cohort': { label: 'Cohort', selected: false, options: ['Cohort 5', 'Cohort 6', 'Cohort 7', 'Cohort 8', 'Cohort 9', 'Cohort 10', 'Cohort 11', 'Cohort 12', 'Cohort 13', 'Cohort 14', 'Cohort 15', 'Cohort 16', 'Cohort 17']},
        'Batch': { label: 'Batch', selected: false, options: ['SCVAPP2001', 'SCVAPP2101', 'SCVAPP2102', 'SCVAPP2201', 'SCVAPP2202', 'SCVAPP2203']}
    }
}

